import {
  useFeatureEntitlements,
  usePermissionEntitlements,
} from '@frontegg/react';
import { BarChartOutlined, PhoneOutlined } from '@ant-design/icons';
import { AppNavMenu } from '..';
import { useDemoStore } from 'src/pages/root/demo/store';

export const usePhoneTriageNavMenus = (): AppNavMenu[] => {
  const { isEntitled: isPhoneTriageModuleEntitled } =
    useFeatureEntitlements('phone-triage');
  const { isEntitled: isPhoneTriageDemoEntitled } =
    useFeatureEntitlements('phone-triage-demo');
  const { isEntitled: hasCallReadAccess } =
    usePermissionEntitlements('calls.read');

  const { setDemoStoreState } = useDemoStore();

  if (isPhoneTriageModuleEntitled) {
    if (hasCallReadAccess) {
      return [
        {
          path: '/phone-triage/calls',
          title: 'Phone',
          icon: <PhoneOutlined />,
          submenu: [
            {
              path: '/phone-triage/analytics',
              title: 'Analytics',
              icon: <BarChartOutlined />,
            },
          ],
        },
      ];
    }
    return [];
  }

  if (isPhoneTriageDemoEntitled) {
    return [
      {
        path: '',
        title: 'Phone',
        icon: <PhoneOutlined />,
        onClick: () => {
          setDemoStoreState({ showPhoneTriageDemo: true });
        },
        showBadge: 'dot',
      },
    ];
  }

  return [];
};
